import { UseFormSetValue } from "react-hook-form";
import CreateShipmentData from "./CreateEditShipmentData";

// One setter per field of the cargo dialog's form, marking the field as
// changed by the user. react-hook-form's setValue can only type a field whose
// name is known where it is called; with one setter per name, code that only
// knows the name at runtime (the merge of someone else's changes, DORA-441)
// can still write a field type-checked: `setters[field]?.(values[field])`.
// Every field of the form must have one (Required below), so a new field
// can't be missed.
export type FormFieldSetters = {
  [K in keyof CreateShipmentData]: (value: CreateShipmentData[K]) => void;
};

export const formFieldSetters = (
  setValue: UseFormSetValue<CreateShipmentData>
): Required<FormFieldSetters> => {
  const options = { shouldDirty: true };
  return {
    clientId: (value) => setValue("clientId", value, options),
    invoiceRef: (value) => setValue("invoiceRef", value, options),
    type: (value) => setValue("type", value, options),
    qualities: (value) => setValue("qualities", value, options),
    requirements: (value) => setValue("requirements", value, options),
    products: (value) => setValue("products", value, options),
    description: (value) => setValue("description", value, options),
    description2: (value) => setValue("description2", value, options),
    cargoTagId: (value) => setValue("cargoTagId", value, options),
    adr: (value) => setValue("adr", value, options),
    adrText: (value) => setValue("adrText", value, options),
    hideForDrivers: (value) => setValue("hideForDrivers", value, options),
    invoiceStatus: (value) => setValue("invoiceStatus", value, options),
    customerContactId: (value) =>
      setValue("customerContactId", value, options),
    clientContact: (value) => setValue("clientContact", value, options),
    clientContactPhone: (value) =>
      setValue("clientContactPhone", value, options),
    clientContactEmail: (value) =>
      setValue("clientContactEmail", value, options),
    driverCanAddDropoffs: (value) =>
      setValue("driverCanAddDropoffs", value, options),
    driverCanRegisterTime: (value) =>
      setValue("driverCanRegisterTime", value, options),
    driverCanMoveFromToUndispatched: (value) =>
      setValue("driverCanMoveFromToUndispatched", value, options),
    ref: (value) => setValue("ref", value, options),
    note: (value) => setValue("note", value, options),
    assignedTeamId: (value) => setValue("assignedTeamId", value, options),
    minTemperature: (value) => setValue("minTemperature", value, options),
    maxTemperature: (value) => setValue("maxTemperature", value, options),
    containerNo: (value) => setValue("containerNo", value, options),
    pickupList: (value) => setValue("pickupList", value, options),
    dropoffList: (value) => setValue("dropoffList", value, options),
    stopUnits: (value) => setValue("stopUnits", value, options),
    cmrConfigs: (value) => setValue("cmrConfigs", value, options),
    extraCo2Elements: (value) => setValue("extraCo2Elements", value, options),
    revision: (value) => setValue("revision", value, options),
    clientCargoTemplateId: (value) =>
      setValue("clientCargoTemplateId", value, options),
    INVOICE_REF_LOCKED: (value) =>
      setValue("INVOICE_REF_LOCKED", value, options),
    LOADING_REF_LOCKED: (value) =>
      setValue("LOADING_REF_LOCKED", value, options),
  };
};
